export const testimonialContentArabic = {
    heading: "موثوق بها من قبل الشركات الرائدة في العالم",
    subHeading: "عملاؤنا يقولون ممتاز",
    testimonialDescription: "لقد حصلنا على جائزة أفضل شركة لتطوير البرمجيات للعام من بايونير في عام 2021. ونحن نقدم نفس الخبرة والتفاني والرؤية والقناعة في كل خدمة نقدمها.",
    clientTesimonailHeading: "شهادات العملاء"
}

export const testimonialsArabic = [
    {
        name: "Amanda H",
        company: "JM Test",
        profileImage: "/images/profile-user.png",
        logoImage: "/images/JM_Test_Systems.jpg",
        text: "لقد كان العمل مع Bitsclan حيويًا للغاية لمبادراتنا التنظيمية لتطوير الويب، وصيانة مواقع الويب، وحملات البريد الإلكتروني، وتصميم الجرافيك، ومشاريع التسويق الرقمي. فهم لا يقومون بعمل رائع فحسب، بل يتميزون أيضًا بالاستجابة السريعة والدقة، وقد تمكنوا من مساعدتنا في تلبية احتياجاتنا بأي شكل احتجناه."
    },
    {
        name: "Roberto",
        company: "Ratech Services",
        profileImage: "/images/profile-user.png",
        logoImage: "/images/RATECH LOGOBLUE.png",
        text: "أريد أن أشكر فريق Bitsclan، فريد وهادي، على إنشاء موقع ويب رائع لنا. لم يكن لدي موقع ويب، ولكن بجهد منسق من قبل الفريق، أصبح موقعي يبدو رائعًا الآن. لقد قمنا بجدولة اجتماعات المشروع من البداية حتى النهاية حتى أتمكن من تقديم الملاحظات. كان الفريق محترفًا وعمليًا وتقنيًا للغاية."
    },
    {
        name: "Johnny",
        company: "Song Heart",
        profileImage: "/images/profile-user.png",
        logoImage: "/images/icon-logo.svg",
        text: "كان العمل مع Bitsclan وفريقهم رائعًا. في فترة قصيرة، تمكنوا من فهم رؤيتنا والتنفيذ بسرعة. إنهم منظمون للغاية ويتواصلون بانتظام ووضوح. الجميع يثني على مدى احترافية ونظافة موقعنا على الويب. من الرائع الاستيقاظ ورؤية جميع التغييرات التي تم إجراؤها. نحن سعداء جدًا ونتطلع إلى مواصلة العمل مع Bitsclan."
    },
    {
        name: "Gregor Hakkenberg",
        company: "Immogo",
        profileImage: "/images/profile-user.png",
        logoImage: "/images/logo-2.png",
        text: "خدمة جيدة بشكل لا يصدق! موقعي العقاري القديم جدًا الذي يحتوي على برامج مخصصة عفا عليها الزمن كان بحاجة إلى بعض الإصلاحات البسيطة. بدت المهمة بسيطة، ولكنها كانت أكثر تعقيدًا بكثير مما كان متوقعًا. لقد تعمق فريق Bitsclan في المشاكل التقنية، واستمر في العمل حتى وجد الحل أخيرًا. كل شيء يعمل مرة أخرى ويمكنني الاستمرار في تقديم الخدمة لعملائي."
    }
];